import propTypes from "prop-types";

const Header = ({ title }) => {
  return (
    <header>
      <nav className="navbar navbar-expand-md navbar-dark bg-dark">
        <div className="col-md-3">
          <div className="container-fluid">
            <a
              className="navbar-brand fs-4 fw-bold ps-5"
            >
              {title}
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

Header.defaultProps = {
  title: "Solana Stake Reward Tracker ",
};

Header.propTypes = {
  title: propTypes.string.isRequired,
};

export default Header;
